module.exports = __webpack_public_path__ + "img/48.e708c820.jpg";